import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { I18NextModule } from 'angular-i18next';
import { PageNotFoundComponent } from '../../components/page-not-found/page-not-found.component';
import { Paths } from '../../enums/paths.enum';
import { RouteLabels } from '../../enums/routeLabels.enum';
import { TasksAndClosingAdvertisingPage } from '../../microservices/cpmm/tasks-and-closing-advertising/tasks-and-closing-advertising.page';
import { AnnualReportPage } from '../../microservices/ms-annual-reports/annualreport.page';
import { CompaniesPage } from '../../microservices/ms-companies/companies.page';
import { PersonsPage } from '../../microservices/ms-persons/persons.page';
import { OrganizationPage } from '../../microservices/ms-organization/organization.page';
import { TasksPage } from '../../microservices/ms-tasks/tasks.page';
import { UserAccountPage } from '../../microservices/ms-users/user-account.page';
import { UserNotificationPage } from '../../pages/user-notifications/user-notification.page';
import { NotificationDrawerComponent } from '@modeso/aumico-lib-core-fe';
import { AuthGuard } from '../../shared/auth.guard';
import { HomePage } from './home-module.page';

const routes: Routes = [
    {
        path: '',
        component: HomePage,
        children: [
            { path: '', redirectTo: `${Paths.PROJECT}`, pathMatch: 'full' },
            {
                path: `${Paths.TASKS}`,
                component: TasksPage,
                loadChildren: () => import('../../microservices/ms-tasks/tasks.module').then((m) => m.TasksModule),
                canActivate: [AuthGuard],
                data: {
                    label: RouteLabels.TASKS,
                    canSeeNavigationLinkRoles: ['AnnualReportUser'],
                },
            },
            {
                path: `${Paths.CLOSING_AND_TASKS}`,
                component: TasksAndClosingAdvertisingPage,
                canActivate: [AuthGuard],
                data: {
                    label: RouteLabels.CLOSING_AND_TASKS,
                    canSeeNavigationLinkRoles: ['AnnualReportUser'],
                    new: true,
                },
            },
            {
                path: `${Paths.PROJECT}`,
                component: AnnualReportPage,
                loadChildren: () =>
                    import('../../microservices/ms-annual-reports/annualreport.module').then(
                        (m) => m.AnnualReportModule,
                    ),
                canActivate: [AuthGuard],
                data: {
                    label: RouteLabels.PROJECT_MAIN_NAVIGATION,
                    canSeeNavigationLinkRoles: ['AnnualReportUser'],
                },
            },
            {
                path: `${Paths.COMPANIES}`,
                component: CompaniesPage,
                loadChildren: () =>
                    import('../../microservices/ms-companies/companies.module').then((m) => m.CompaniesModule),
                canActivate: [AuthGuard],
                data: {
                    label: RouteLabels.COMPANIES_MAIN_NAVIGATION,
                    canSeeNavigationLinkRoles: ['AnnualReportUser'],
                },
            },
            // REV-22155: natural persons, same roles as companies
            {
                path: `${Paths.PERSONS}`,
                component: PersonsPage,
                loadChildren: () =>
                    import('../../microservices/ms-persons/persons.module').then((m) => m.PersonsModule),
                canActivate: [AuthGuard],
                data: {
                    label: RouteLabels.PERSONS_MAIN_NAVIGATION,
                    canSeeNavigationLinkRoles: ['AnnualReportUser'],
                },
            },
            // {
            //     path: `${Paths.COMPANY_VALUATION}`,
            //     component: CompaniesPage,
            //     loadChildren: () =>
            //         import('../../microservices/ms-company-valuation/companyValuation.module').then(
            //             (m) => m.CompanyValuationModule,
            //         ),
            //     canActivate: [AuthGuard],
            //     data: {
            //         label: RouteLabels.COMPANY_VALUATION,
            //         canSeeNavigationLinkRoles: ['AnnualReportUser'],
            //     },
            // },
            {
                path: `${Paths.COMPANY_VALUATION}`,
                component: CompaniesPage,
                loadChildren: () =>
                    import('../../microservices/ms-closing-process-enabling/enabling-closing-process.module').then(
                        (m) => m.EnablingClosingProcessModule,
                    ),
                canActivate: [AuthGuard],
                data: {
                    label: RouteLabels.CLOSING_PROCESS_ENABLING,
                    canSeeNavigationLinkRoles: ['AnnualReportUser'],
                },
            },
            {
                path: `${Paths.ORGANIZATION}`,
                component: OrganizationPage,
                loadChildren: () =>
                    import('../../microservices/ms-organization/organization.module').then((m) => m.OrganizationModule),
                canActivate: [AuthGuard],
                data: {
                    label: RouteLabels.ORGANIZATION,
                    canSeeNavigationLinkRoles: ['AnnualReportUser'],
                },
            },
            {
                path: `${Paths.USER_ACCOUNT}`,
                component: UserAccountPage,
                loadChildren: () =>
                    import('../../microservices/ms-users/user-account.module').then((m) => m.UserAccountModule),
                canActivate: [AuthGuard],
                data: {
                    label: RouteLabels.USER_ACCOUNT,
                    canSeeNavigationLinkRoles: ['AnnualReportUser'],
                },
            },
            {
                path: `${Paths.NOT_FOUND}`,
                component: PageNotFoundComponent,
            },
            { path: '**', component: PageNotFoundComponent },
        ],
    },
];

@NgModule({
    declarations: [UserNotificationPage],
    imports: [CommonModule, I18NextModule, RouterModule.forChild(routes), NotificationDrawerComponent],
    exports: [UserNotificationPage],
})
export class HomeModule {}
